import ContentManager from '@tribal-worldwide-london/fa-content';
import {
  GetPdbByMarketingShortCodeDto,
  GetPdbByOrderDto,
  GetPdbByVinDto,
  PdbLong,
  VwgPdbService,
} from '@tribal-worldwide-london/fa-pdb-service-vwg';
import { GlobalStoreStateConfiguration } from '@/stores/globalStore';
import { reduceDataByKey } from '../utils/object';
import { handleAllErrors } from '../utils/response';

export type PdbLoaderFunctionArgs = {
  params: {
    pdbId: string;
    configurations: GlobalStoreStateConfiguration[];
  };
};

export type PdbLoaderServiceArgs = {
  pdbService: VwgPdbService;
};

export interface PdbLoaderData {
  [key: string]: PdbLong;
}

const pdbLoader = async (
  { pdbService }: PdbLoaderServiceArgs,
  { params }: PdbLoaderFunctionArgs,
  contentManager: Pick<ContentManager, 'get'>
) => {
  const { configurations, pdbId } = params;
  const fullUrls: string[] = [];

  const pdbRequests = configurations.map(
    ({ marketingShortCode, orderNumber, vin, fullUrl }) => {
      if (marketingShortCode) {
        fullUrls.push(fullUrl); 
        return pdbService.getPdbByMarketingShortCode(
          new GetPdbByMarketingShortCodeDto(pdbId, marketingShortCode)
        );
      }

      if (orderNumber) {
        fullUrls.push(fullUrl);
        return pdbService.getPdbByOrder(
          new GetPdbByOrderDto(pdbId, orderNumber)
        );
      }

      if (vin) {
        fullUrls.push(fullUrl);
        return pdbService.getPdbByVin(
          new GetPdbByVinDto(pdbId, vin)
        );
      }
    }  
  );

  const pdbResponses = await Promise.all(pdbRequests);
  let hasSuccessfulResponse = false;
  pdbResponses.forEach(response => {
    if (response?.success) {
      hasSuccessfulResponse = true;
    } 
  });

  if (!hasSuccessfulResponse) {
    handleAllErrors(pdbResponses, contentManager, hasSuccessfulResponse);
  }

  const pdbResponsesByFullUrl = reduceDataByKey(
    fullUrls,
    (key: string, i: number) => ({
      [key]: pdbResponses[i]?.data,
    })
  );

  return Promise.resolve(pdbResponsesByFullUrl);
};

export default pdbLoader;
